module.exports = __webpack_public_path__ + "img/5.ebdaec04.jpg";